// a linked app's name is "soma on <machine>" (older apps: "soma harness on <machine>"); show the machine
export default function macName(name) {
  return String(name || 'your mac').replace(/^soma( harness)? on /i, '') || 'your mac';
}
